import React from 'react';
import styled from 'styled-components';
import { standardColours, brandColours, fontSize } from '../../styles';

const StyledDateRange = styled.span`
  display: inline-block;
  padding: 3px 8px 5px;
  color: ${standardColours.white};
  ${fontSize(14)};
  background-color: ${brandColours.secondary};
  border-radius: 15px;
`;

export const DateRange = ({
  startDate,
  startDateFormatted,
  endDate,
  endDateFormatted,
  ...props
}) => {
  const [startDateDay, startDateMonth, startDateYear] =
    startDateFormatted.split(' ');
  const [endDateDay, endDateMonth, endDateYear] = endDateFormatted.split(' ');

  if (startDateDay !== endDateDay) {
    startDateFormatted = startDateDay;
  }

  if (startDateMonth !== endDateMonth) {
    startDateFormatted += ` ${startDateMonth}`;
  }

  if (startDateYear !== endDateYear) {
    startDateFormatted += ` ${startDateYear}`;
  }

  return (
    <StyledDateRange {...props}>
      {startDateFormatted !== endDateFormatted && (
        <>
          <time dateTime={startDate}>{startDateFormatted}</time>
          {` - `}
        </>
      )}
      <time dateTime={endDate}>{endDateFormatted}</time>
    </StyledDateRange>
  );
};
